import "./SpecialNeeds.css";
import BackBtn from "./Shared/BackBtn";
import CheckIcon from "@mui/icons-material/CheckCircleOutline";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../../../../../redux-store/auth/actions";
import backend from "../../../../../../../api";
import { useState } from "react";
import { useSnackbar } from "notistack";
import { motion, easeOut } from "framer-motion";

// Predefined options for special needs
const defaultOptions = [
  "Mobility Assistance",
  "Health Conditions",
  "Hearing or Vision Impairment",
  "Elderly Support",
  "Dietary Needs",
];

export default function NeedsScreen() {
  const { user } = useSelector((s) => s.auth);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // Combine default options with unique otherNeeds values from the user
  const options = [
    ...defaultOptions,
    ...(user?.otherNeeds?.trim() && !defaultOptions.includes(user.otherNeeds.trim())
      ? [user.otherNeeds.trim()]
      : []),
  ].filter((value, index, self) => self.indexOf(value) === index); // Deduplicate

  const [sel, setSel] = useState(new Set(user?.specialNeeds || []));
  const [other, setOther] = useState("");
  const [saving, setSaving] = useState(false);

  const toggle = (o) => {
    const s = new Set(sel);
    s.has(o) ? s.delete(o) : s.add(o);
    setSel(s);
  };

  const save = async () => {
    // Validation for otherNeeds
    const trimmedOther = other.trim();
    if (trimmedOther && trimmedOther.length < 2) {
      enqueueSnackbar("Other needs must be at least 2 characters long.", { variant: "warning" });
      return;
    }

    setSaving(true);
    try {
      // Add otherNeeds to specialNeeds if non-empty and not already in specialNeeds
      const specialNeeds = [...sel];
      if (trimmedOther && !specialNeeds.includes(trimmedOther)) {
        specialNeeds.push(trimmedOther);
      }

      const body = { specialNeeds, otherNeeds: trimmedOther };
      const { data } = await backend.put(`/api/user/${user._id}`, body);
      dispatch(setUserData({ ...user, ...data.data }));
      enqueueSnackbar("Special needs updated!", { variant: "success" });
      setOther('');
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || "Error updating special needs", {
        variant: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <motion.div
      className="pf-wrap"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: easeOut }}
    >
      <BackBtn />
      <h2 className="pf-modal-title" style={{ textAlign: "left" }}>
        Special Needs
      </h2>

      <div className="pf-needs-list">
        {options.length === 0 ? (
          <div className="pf-empty">No special needs options available.</div>
        ) : (
          options.map((o) => (
            <div
              key={o}
              className={`pf-need-row ${sel.has(o) ? "pf-on" : ""}`}
              onClick={() => toggle(o)}
            >
              <span>{o}</span>
              {sel.has(o) && <CheckIcon sx={{ color: "var(--brand)" }} />}
            </div>
          ))
        )}
      </div>

      {/* Other needs input */}
      <input
        className="pf-input"
        placeholder="Other needs (type here)"
        value={other}
        onChange={(e) => setOther(e.target.value)}
      />

      <button className="pf-save" onClick={save} disabled={saving}>
        {saving ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Save"}
      </button>
    </motion.div>
  );
}